<template>
    <div :class="[{'app-en':lang === 'en'}, 'app-canvas-wrap']">
        <Nav ref="navchild"></Nav>
        <Loader :speed="loadprogress" v-if="!hadLoaded" />
        <div ref="webgl" id="webgl"></div>
        <!-- logo -->
        <div class="logo">
            <a href="/"><img src="../assets/logo.png" /></a>
        </div>
        <!-- CN|EN -->
        <language @custom-event="handleChildEvent" />
        <!-- 菜单栏 -->
        <div class="app-toolbar">
            <div class="app-toolbar-circle">
                <div class="ring"></div>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
                    <g class="ring">
                        <g class="toolbar-item" @click="openLink()">
                            <path
                                d="M 482.13602837739217 125.84452286971282 L 452.40303192456616 51.57508822842692 A 720 720 0 0 1 583.7391040605069 13.011337970850718 L 598.8792036093395 91.56563375186738 A 640 640  0 0 0 482.13602837739217 125.84452286971282 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1031">官 网</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="36" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1031">Website</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'upper'}, 'toolbar-item']" @click="selectToobar('upper')">
                            <path
                                d="M 598.8792036093395 91.56563375186738 L 583.7391040605069 13.011337970850718 A 720 720 0 0 1 720.0000000000024 0 L 720.0000000000022 80 A 640 640  0 0 0 598.8792036093395 91.56563375186738 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="40" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1032">拆 卸</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="20" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1032">principle</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'down'}, 'toolbar-item']" @click="selectToobar('down')">
                            <path
                                d="M 720 80 L 720 0 A 720 720 0 0 1 856.2608959394953 13.011337970851173 L 841.1207963906625 91.56563375186772 A 640 640  0 0 0 720 80 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="42" @mouseenter="greet" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1000">装 配</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="28" @mouseenter="greet" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1000">Assemble</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'outer'}, 'toolbar-item']" @click="selectToobar('outer')">
                            <path
                                d="M 841.1207963906625 91.56563375186772 L 856.2608959394953 13.011337970851173 A 720 720 0 0 1 987.5969680754358 51.57508822842772 L 957.8639716226096 125.8445228697135 A 640 640  0 0 0 841.1207963906625 91.56563375186772 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="42" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1001">型 号</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="46" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1001">Type</textPath>
                            </text>
                          </g>
                          <!-- 椭圆  A(rx, ry, xr, laf, sf, x, y)
                          rx: 椭圆X轴半径
                          ry: 椭圆Y轴半径
                          xr: 椭圆旋转角度
                          laf: 是否选择弧长较长的那一段。0: 短边（小于180度）; 1: 长边（大于等于180度）
                          sf: 是否顺时针绘制。0: 逆时针; 1: 顺时针
                          x: 终点X轴坐标
                          y: 终点Y轴坐标 -->
                    </g>
                    <defs>
                        <path id="SvgjsPath1000"
                            d="M 720 49 L 720 48 A 672 672 0 0 1 847.1768362101957 60.143915439461125 L 846.9875849658353 61.1258441367238 A 671 671  0 0 0 720 49 z">
                        </path>
                        <path id="SvgjsPath1001"
                            d="M 846.9875849658353 61.1258441367238 L 847.1768362101957 60.143915439461125 A 672 672 0 0 1 969.7571702037401 96.13674901319928 L 969.3855077480798 97.06511694621531 A 671 671  0 0 0 846.9875849658353 61.1258441367238 z">
                        </path>
                        <path id="SvgjsPath1031"
                            d="M 470.6144922519221 97.06511694621452 L 470.2428297962618 96.13674901319848 A 672 672 0 0 1 592.8231637898064 60.14391543946067 L 593.0124150341668 61.12584413672346 A 671 671  0 0 0 470.6144922519221 97.06511694621452 z">
                        </path>
                        <path id="SvgjsPath1032"
                            d="M 593.0124150341668 61.12584413672346 L 592.8231637898064 60.14391543946067 A 672 672 0 0 1 720.0000000000023 48 L 720.0000000000023 49 A 671 671  0 0 0 593.0124150341668 61.12584413672346 z">
                        </path>
                    </defs>
                </svg>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'upper'">
                    <div
                      v-for="(item,index) in upperObj"
                      :key="index"
                      :class="[{'active':upperActive === item.id}, 'app-submenu-item']"
                      @click="upperAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'down'">
                    <div
                      v-for="(item,index) in downObj"
                      :key="index"
                      :class="[{'active':downActive === item.id}, 'app-submenu-item']"
                      @click="downAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
            <div class="app-submenu-wrap img-wrap" v-if="toobarActive === 'outer'">
                    <div
                      v-for="(item,index) in outerObj"
                      :key="index"
                      :class="[{'active':outerActive === item.id}, 'app-submenu-item img']"
                      @click="outerAnimate(item)"
                      :style="{backgroundImage:'url('+ item.img +') !important'}"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
        </div>

        <!-- 注意事项文字 -->
        <transition>
          <div class="app-text" v-if="attentionStatus&&attentionText">
            <div class="title" @click="shownote()">
                <img src="../assets/images/text.png" />
                <span  v-show="lang == 'cn'">注意</span>
                <span  v-show="lang == 'en'">NOTE</span>
            </div>
            <div class="content" v-html="attentionText" v-show="is_hidenote"></div>
          </div>
        </transition>

        <!-- <div @click="test" class="test">测试</div> -->

    </div>
</template>

<script>
    import * as THREE from  'three';
    import TWEEN from '@tweenjs/tween.js';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
    import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
    import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'
    import Loader from './Loader.vue';
    import Nav from './nav.vue';
    import language from './language.vue';

    export default {
        components: {
            Loader,
            Nav,
            language,
        },
        data() {
            return {
                timer: null, // 定时器
                hadLoaded: false, // 是否已加载完毕
                loadprogress: 0, // 加载进度
                modelLoaded: false, // 模型是否加载

                Clock: null, // 用于跟踪时间
                camera: null, // 相机对象
                renderer: null, // 渲染器对象
                container: null, // DOM节点
                controls: null, // 轨道控制器
                containerW: 0, // DOM宽度
                containerH: 0, // DOM高度
                model: null, //模型
                toobarActive: null, // 工具栏状态
                is_hidenote:true,

                attentionStatus: false, // 注意事项状态
                attentionText: null, // 注意事项文字
                upperActive:null, //当前选项1下标
                downActive:null, //当前选项2下标
                outerActive:null,//当前选项3下标
                modelanimationList:[], //动画列表
                selectobject: '', //当前选择的选项

                settiemoutlist:[],

                lang: 'cn', // 语言
                upperObj:[ //拆卸选项
                  {
                    id: 0,
                    text: '第一步', //菜单显示
                    en_text: 'Step 1', //菜单显示(英文)
                    warn: '<p>需要先松开顶持螺丝，再拆下冷却板。</p>',
						        en_warn: '<p>Loosen the top screw first, then remove the cooling element.</p>',
                    animate_number: '0',
                    camera_position:{
                      x:50,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 1,
                    text: '第二步', //菜单显示
                    en_text: 'Step 2', //菜单显示(英文)
                    warn: '<p>需在加温状态下进行，利用盖板两对角上的拆卸槽交替将盖板顶开，并注意做好标记。</p>',
						        en_warn: '<p>Operate during the heated state.</p><p>Use the grooves on the two corners of the cover to open it alternately.</p><p>Make sure to mark down.</p>',
                    show_name:["zjt1","zjt2"],
                    hide_name:["zcb","ycb","youtou"],
                    animate_number: '1',
                    camera_position:{
                      x:-50,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 2,
                    text: '第三步', //菜单显示
                    en_text: 'Step 3', //菜单显示(英文)
                    warn: '<p>需在加温状态下进行，利用盖板两对角上的拆卸槽交替将盖板顶开，并注意做好标记。</p>',
						        en_warn: '<p>Operate during the heated state.</p><p>Use the grooves on the two corners of the cover to open it alternately</p><p>Make sure to mark down.</p>',
                    show_name:["yjt1","yjt2"],
                    hide_name:["zcb","ycb","youtou","zl1","zl2","zl3","zl4","zl5","zl6","zl7","zl8","zuoban1","zjx1"],
                    animate_number: '2',
                    camera_position:{
                      x:50,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 3,
                    text: '第四步', //菜单显示
                    en_text: 'Step 4', //菜单显示(英文)
                    warn: '<p>需在加温状态下进行，止转螺丝安装在驱动轴的末端，操作时应防止轴承卡死。保存好键销以便安装，并注意做好标记。</p>',
                    en_warn: '<p>Operate during the heated state.</p><p>The screw should be installed on the end of the drive shaft.</p><p>Prevent bearing from stuck during operation.</p><p>Keep the dowel pin for later installation and make sure to mark down.</p>',
                    hide_name:["zcb","ycb","youtou","zl1","zl2","zl3","zl4","zl5","zl6","zl7","zl8","zuoban1","zjx1","yl1","yl2","yl3","yl4","yl5","yl6","yl7","yl8","youban","yjx"],
                    animate_number: '3',
                    camera_position:{
                      x:50,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 4,
                    text: '第五步', //菜单显示
                    en_text: 'Step 5', //菜单显示(英文)
                    warn: '<p>需在加温状态下进行，先从型腔内取出驱动轴，再取出从动轴。</p>',
						        en_warn: '<p>Operate during the heated state.</p><p>Remove propeller shaft from cavity first, then remove driven shaft.</p>',
                    hide_name:["zcb","ycb","youtou","zl1","zl2","zl3","zl4","zl5","zl6","zl7","zl8","zuoban1","zjx1","yl1","yl2","yl3","yl4","yl5","yl6","yl7","yl8","youban","youzhou","yjx"],
                    animate_number: '4',
                    camera_position:{
                      x:50,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 5,
                    text: '第六步', //菜单显示
                    en_text: 'Step 6', //菜单显示(英文)
                    warn: '<p>需在加温状态下进行。保存好键销以便安装，并注意做好标记。</p><p>拆卸完成后检查所有组件是否有损伤，磨损的配件需要更换。大于220等级的砂纸可用来清理孔腔，用粗砂纸抛光后，再用细砂纸抛光。</p>',
                    en_warn: '<p>Operate during the heated state.</p><p>Keep the dowel pin for later installation and make sure to mark down.</p><p>Check the abrasiveness of all components. Wearing parts should be replaced.</p><p>Choose sandpaper that is greater than 220 grit that can be used in cleaning the cavity.</p><p>Choose coarse sandpaper first, then repolish it with fine sandpaper.</p>',
                    animate_number: '5',
                    camera_position:{
                      x:-50,
                      y:30,
                      z:70
                    }
                  },
                ],
                downObj: [ //装配选项
                  {
                    id: 0,
                    text: '第一步', //菜单显示
                    en_text: 'Step 1', //菜单显示(英文)
                    warn: '<p>安装非驱动端轴承时要对齐，不要忘记安装键销，回流减压孔一定对向进口方向。</p><p>从驱动端检查，轴承上的润滑槽要对向出口方向。</p>',
                    en_warn: '<p>Line up upper bearing and lower bearing.</p><p>Install the dowel pin.</p><p>Change the direction of the Backflow Assembly Relief Hole to the inlet.</p><p>Check the drive side, the lubricating groove on the bearing should face the outlet direction.</p>',
                    animate_number: '6',
                    camera_position:{
                      x:-50,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 1,
                    text: '第二步', //菜单显示
                    en_text: 'Step 2', //菜单显示(英文)
                    warn: '<p>在安装盖板紧固螺丝时,先装定位销，内六角螺丝要对边拧紧，防止盖板卡住。</p><p>最后要检查盖板是否装配整齐,边缘不能有突起，否则会影响齿轮泵的密封性。</p>',
                    en_warn: '<p>When installing the cover plate fastening screws, install the positioning pins first, and tighten the hexagon socket head screws on opposite sides to prevent the cover plate from being stuck.</p><p>Check whether the cover plate is neatly assembled, and there should be no protrusions on the edge, otherwise, it will affect the sealing performance of the gear pump.</p>',
                    animate_number: '7',
                    camera_position:{
                      x:-50,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 2,
                    text: '第三步', //菜单显示
                    en_text: 'Step 3', //菜单显示(英文)
                    warn: '<p>从驱动端安装轴。先装从动轴,从动轴要涂高温润滑脂。</p><p>再将涂有高温润滑脂的驱动轴安装到泵内。</p>',
                    en_warn: '<p>Install the shaft from the drive side.</p><p>Install the driven shaft first, and the driven shaft should be coated with High-Temp grease.</p><p>Install the drive shaft with High-Temp grease into the pump.</p>',
                    animate_number: '8',
                    camera_position:{
                      x:50,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 3,
                    text: '第四步', //菜单显示
                    en_text: 'Step 4', //菜单显示(英文)
                    warn: '<p>安装驱动端轴承时, 让回流减压孔对准进口方向。</p><p>再安装驱动轴的轴承,回流孔对准进口，不要忘记安装键销。</p><p>检查轴承是否到位,否则要重新清理轴承孔。</p>',
                    en_warn: '<p>Make sure Backflow Assembly Relief Hole faces to inlet when Installing the drive side bearing.</p><p>Install the bearing of the drive shaft, and do not forget to install the dowel pin.</p><p>Check the position of the bearing. If something goes wrong, clean the bearing hole again.</p>',
                    animate_number: '9',
                    camera_position:{
                      x:50,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 4,
                    text: '第五步', //菜单显示
                    en_text: 'Step 5', //菜单显示(英文)
                    warn: '<p>在安装盖板紧固螺丝时,先装定位销，内六角螺丝要对边拧紧，防止盖板卡住。</p><p>最后要检查盖板是否装配整齐,边缘不能有突起，否则会影响齿轮泵的密封性。</p>',
                    en_warn: '<p>When installing the cover plate fastening screws, install the positioning pins first, and tighten the hexagon socket head screws on opposite sides to prevent the cover plate from being stuck.</p><p>Check whether the cover plate is neatly assembled, and there should be no protrusions on the edge, otherwise, it will affect the sealing performance of the gear pump.</p>',
                    animate_number: '10',
                    camera_position:{
                      x:50,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 5,
                    text: '第六步', //菜单显示
                    en_text: 'Step 6', //菜单显示(英文)
                    warn: '<p>将标有驱动端记号的冷却板装在驱动端螺纹套上，将标有非驱动端记号的冷却板装在非驱动端螺纹套上，并拧紧顶持螺丝。</p>',
                    en_warn: '<p>Install the cooling element marked with the drive side on the threaded sleeve of the drive side.</p><p>Install the cooling element marked with the Non-drive side on the threaded sleeve of the Non-drive side.</p><p>Tighten the top screw.</p>',
                    animate_number: '11',
                    camera_position:{
                      x:-50,
                      y:30,
                      z:70
                    }
                  },
                ],
                outerObj: [ //型号选项
                  {
                    id: 0,
                    text: '电加热带冷却板',
                    warn: '<p>计量泵主体采用电加热，配轴端防渗漏密封冷却板。</p>',
                    en_warn: 'The metering pump adopts electric heating and is equipped with a sealing cooling plate at the shaft side.',
                    en_text: 'Electric heating with cooling element',
                    img: require('../assets/images/version1.png'),
                    animate_number: '14',
                    camera_position:{
                      x:0,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 1,
                    text: '电加热',
                    warn: '<p>计量泵主体采用电加热。</p>',
                    en_warn: 'The metering pump adopts electric heating.',
                    en_text: 'Electric heating',
                    img: require('../assets/images/version2.png'),
                    hide_name:["zcb","ycb"],
                    animate_number: '14',
                    camera_position:{
                      x:0,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 2,
                    text: '油加温',
                    warn: '<p>计量泵主体采用油加热。</p>',
                    en_warn: 'The metering pump adopts oil heating.',
                    en_text: 'Oil heating',
                    img: require('../assets/images/version3.png'),
                    show_name:["zx2"],
                    hide_name:["zcb","zx1","dianjia","ycb"],
                    // animate_number: '12',
                    camera_position:{
                      x:0,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 3,
                    text: '油加温带冷却版',
                    warn: '<p>计量泵主体采用油加热，配轴端防渗漏密封冷却板。</p>',
                    en_warn: 'The metering pump adopts oil heating and is equipped with a sealing cooling plate at the shaft side.',
                    en_text: 'Oil heating with cooling element',
                    img: require('../assets/images/version4.png'),
                    show_name:["zx2"],
                    hide_name:["zx1","dianjia"],
                    animate_number: '14',
                    camera_position:{
                      x:0,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 4,
                    text: '内冷电加热',
                    warn: '<p>计量泵主体采用电加热，齿轮轴采用芯部通水冷却。</p>',
                    en_warn: 'The metering pump adopts electric heating, and the gear shaft is cooled by water through the core.',
                    en_text: 'Electric heating with inner cooling',
                    img: require('../assets/images/version5.png'),
                    show_name:["yuanzhu","zuoban2","zjx2","luowen3"],
                    hide_name:["zcb","ycb","zuoban1"],
                    animate_number: '13',
                    camera_position:{
                      x:0,
                      y:30,
                      z:70
                    }
                  },
                  {
                    id: 5,
                    text: '内冷油加温',
                    warn: '<p>计量泵主体采用油加热，齿轮轴采用芯部通水冷却。</p>',
                    en_warn: 'The metering pump adopts oil heating, and the gear shaft is cooled by water through the core.',
                    en_text: 'Oil heating with inner cooling',
                    img: require('../assets/images/version6.png'),
                    show_name:["yuanzhu","zuoban2","zx2","zjx2","luowen3"],
                    hide_name:["zcb","ycb","zuoban1","dianjia","zx1"],
                    animate_number: '12',
                    camera_position:{
                      x:0,
                      y:30,
                      z:70
                    }
                  }
                ],
            }
        },
        methods: {
          greet () {},
          /**
           * @description 打开链接
           * @param {*} link
           */
          openLink: function(link) {
            if (this.lang == 'cn') {
              window.open('https://www.jc-times.com/', '_blank');
            } else {
              window.open('https://en.jc-times.com/', '_blank');
            }
          },
          /**
           * @description 相机动画
           */
          tweenCamera: function(oldP, oldT, newP, newT, callBack) {
            var _this = this
            var tween = new TWEEN.Tween({
              x1: oldP.x, // 相机x
              y1: oldP.y, // 相机y
              z1: oldP.z, // 相机z
              x2: oldT.x, // 控制点的中心点x
              y2: oldT.y, // 控制点的中心点y
              z2: oldT.z  // 控制点的中心点z
            });
            tween.to({
              x1: newP.x,
              y1: newP.y,
              z1: newP.z,
              x2: newT.x,
              y2: newT.y,
              z2: newT.z
            }, 1000);
            tween.onUpdate(function (object) {
              _this.camera.position.x = object.x1;
              _this.camera.position.y = object.y1;
              _this.camera.position.z = object.z1;
              _this.controls.target.x = object.x2;
              _this.controls.target.y = object.y2;
              _this.controls.target.z = object.z2;
              _this.controls.update();
            })
            tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            tween.easing(TWEEN.Easing.Cubic.InOut);
            tween.start();
          },

          /**
           * @description 初始化Canvas
           */
          initCanvas: function() {
              let _this = this;

              _this.clock = new THREE.Clock();

              // 创建渲染器
              _this.initRenderer();

              // 创建场景
              _this.initScene();

              // 创建相机
              _this.initCamera();

              // 创建相机控制器
              _this.initControls();

              // 创建环境贴图
              _this.initPmremGenerator();

              // 加载模型
              _this.loadModel();

          },

          /**
           * @description 初始化渲染器
           */
          initRenderer: function() {
              let _this = this;
              _this.container = this.$refs.webgl;
              _this.containerW = this.$refs.webgl.getBoundingClientRect().width;
              _this.containerH = this.$refs.webgl.getBoundingClientRect().height;
              _this.renderer = new THREE.WebGLRenderer({
                  antialias: true,
                  alpha: true
              });
              _this.renderer.setSize(this.containerW,this.containerH);
              _this.renderer.localClippingEnabled = true;
              _this.renderer.clippingPlanes = Object.freeze([])
              _this.renderer.setClearAlpha(0);
              _this.renderer.setPixelRatio(window.devicePixelRatio);
              _this.renderer.outputEncoding = THREE.sRGBEncoding;
              _this.container.appendChild(_this.renderer.domElement);
          },
          /**
           * @description 初始化场景
           */
          initScene: function() {
              let _this = this;
              _this.scene = new THREE.Scene();
          },
          /**
           * @description 初始化相机
           */
          initCamera: function() {
            let _this = this;
            _this.camera = new THREE.PerspectiveCamera(45, this.containerW / this.containerH, 0.1, 10000);
            _this.camera.position.set(0, 30, 70);
            _this.camera.lookAt(_this.scene.position);
          },
          /**
           * @description 初始化相机控制器
           */
          initControls: function() {
              let _this = this;
              _this.controls = new OrbitControls(_this.camera, _this.renderer.domElement);
              _this.controls.enablePan = false;
              _this.controls.enableDamping = true;
              _this.controls.dampingFactor = 0.1;
              _this.controls.maxPolarAngle = Math.PI;
              _this.controls.minPolarAngle = 0;
              _this.controls.enablePan = false;
              _this.controls.enableZoom = true;
          },
          /**
           * @description 初始化环境贴图
           */
          initPmremGenerator: function() {
            let _this = this;
            let pmremGenerator = new THREE.PMREMGenerator(_this.renderer);
            let loaderRGBE = new RGBELoader();
            pmremGenerator.compileEquirectangularShader()
            loaderRGBE.load('../../static/hdr/photo_studio_01_1k.hdr', texture => {
              const envMap = pmremGenerator.fromEquirectangular(texture).texture;
              _this.scene.environment = envMap;
              texture.dispose();
              pmremGenerator.dispose();
            })
          },

          /**
           * @description 加载模型文件
           */
          loadModel: function() {
              let _this = this;
              _this.textrueLoader = new THREE.TextureLoader();
              let loader = new GLTFLoader();

              loader.setMeshoptDecoder(MeshoptDecoder);
              loader.load("../../static/model/jlb/计量泵(6).glb", function(gltf) {
                console.log(gltf,'gltf');
                _this.model = gltf.scene;
                _this.modelanimationList = gltf.animations
                _this.model.scale.set(1.5,1.5,1.5);
                _this.modelLoaded = true;
                _this.scene.add(_this.model);
                _this.animate();

                // 材质共享问题
                _this.model.traverse(function (object) {
                  if (object.isMesh) {
                    object.material = object.material.clone();
                  }
                })

                _this.initmodel()
                _this.optimization_model_meaterial_performance()
              });
          },

          /**
           * @description 循环渲染Canvas
           */
          animate: function() {
            let _this = this;

            _this.rafId = requestAnimationFrame(_this.animate);
            _this.controls.update();
            TWEEN.update();
            if(_this.mixer){
              let mixerUpdateDelta = _this.clock.getDelta();
              _this.mixer.update( mixerUpdateDelta );
            }
            // _this.composer.render(); // 使用处理对象渲染场景
            _this.renderer.render(_this.scene, _this.camera);
            // _this.labelRenderer.render(_this.scene, _this.camera); //渲染html标签
          },
          /**
           * @description 改变窗口大小，重新渲染Canvas
           */
          onResize: function() {
              let _this = this;
              _this.$nextTick(()=>{
                if(_this.$refs.webgl.getBoundingClientRect()){
                  _this.containerW = _this.$refs.webgl.getBoundingClientRect().width
                  _this.containerH = _this.$refs.webgl.getBoundingClientRect().height
                  _this.camera.aspect = _this.containerW / _this.containerH;
                  _this.camera.updateProjectionMatrix();
                  _this.renderer.setSize(_this.containerW, _this.containerH);
                }
              })
              // _this.labelRenderer.setSize(_this.containerW, _this.containerH);
          },
          /**
           * @description 选择语言
           */
          selectLang: function(e) {
              let _this = this;
              _this.lang = e;
              _this.toobarActive = '';
              _this.dismantleActive = '';
              _this.assembleActive = '';
          },
          /**
           * @description 选择菜单
           * @param {String} e 菜单
           */
          selectToobar: function(e) {
            let _this = this
            if ( this.toobarActive == e ) {
              this.toobarActive = '';
              if(_this.clipAction){ //如果有动画则先停止播放
                _this.clipAction.stop()
              }
              this.attentionStatus = false
            }else{
              this.toobarActive = e;
              this.attentionStatus = true
            }
          },
          optimization_model_meaterial_performance(){
            let _this = this;
            _this.model.traverse(function (object) {
              if (object.isMesh && object.material.isMeshPhysicalMaterial) {
                console.log(object,'isMeshPhysicalMaterial');
                // let now_material = object.material
                // // 创建一个新的 MeshStandardMaterial，可以根据需要调整属性
                // let materialStandard = new THREE.MeshStandardMaterial({
                //   color: now_material.color,
                //   roughness: now_material.roughness, // 根据需要调整转换规则
                //   metalness: now_material.metalness, // 金属度
                //   normalMap: now_material.normalMap, // 法线贴图
                //   normalScale: now_material.normalScale, // 法线贴图强度
                //   // 其他属性根据需要进行调整或者添加
                // });
                // // 将模型的材质替换为新的 MeshStandardMaterial
                // object.material = materialStandard;
              }
            })
          },
          clearsettimeout(){
            let _this = this
            if(_this.settiemoutlist.length !=0 ){
              for (let i = 0; i < _this.settiemoutlist.length; i++) {
                clearInterval(_this.settiemoutlist[i])
              }
              _this.settiemoutlist.length = 0
            }
          },
          /**
           * @description 菜单选项1
           * @param {number} e 菜单选项对象
           */
          upperAnimate: function(item) {
            let _this = this;
            this.upperActive = item.id
            this.downActive = null
            this.outerActive = null
            this.selectobject = item
            this.showallcomponents()
            this.initmodel()
            this.clearsettimeout()
            this.attentionStatus = true
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(item.show_name){ //显示
              _this.ShowHideComponents(item.show_name,true)
            }
            if(item.hide_name){ //隐藏
              _this.ShowHideComponents(item.hide_name,false)
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }

            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            if(item.camera_position){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: item.camera_position.x,
                y: item.camera_position.y,
                z: item.camera_position.z,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
            switch (item.id) {
              case 0:
                _this.settiemoutlist.push(
                  setTimeout(() => {
                    var oldP = { //旧的相机位置
                      x: _this.camera.position.x,
                      y: _this.camera.position.y,
                      z: _this.camera.position.z,
                    }
                    var oldT = { //旧的聚焦位置
                      x: _this.controls.target.x,
                      y: _this.controls.target.y,
                      z: _this.controls.target.z,
                    }
                    var newT = { //新的聚焦位置
                      x: 0,
                      y: 0,
                      z: 0,
                    }
                    var newP = { //新的相机位置
                      x: -50,
                      y: 30,
                      z: 70,
                    }
                    _this.tweenCamera(oldP, oldT, newP, newT);
                  }, 4500)
                )
                break;
              case 1:
                // _this.$nextTick(()=>{
                  _this.settiemoutlist.push(
                    setTimeout(() => {
                      _this.ShowHideComponents(["zjt1","zjt2"],false)
                    }, 5000)
                  )
                // })
                break;
              case 2:
                _this.settiemoutlist.push(
                    setTimeout(() => {
                      _this.ShowHideComponents(["yjt1","yjt2"],false)
                    }, 5500)
                  )
                break;
              default:
                break;
            }
          },
          /**
           * @description 菜单选项2
           * @param {Number} e 菜单选项对象
           */
          downAnimate: function(item) {
            let _this = this;
            this.downActive = item.id
            this.upperActive = null
            this.outerActive = null
            this.selectobject = item
            this.showallcomponents()
            this.initmodel()
            this.clearsettimeout()
            this.attentionStatus = true
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(item.hide_name){ //隐藏
              _this.ShowHideComponents(item.hide_name,false)
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            if(item.camera_position){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: item.camera_position.x,
                y: item.camera_position.y,
                z: item.camera_position.z,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }

            switch (item.id) {
              case 5:
                _this.settiemoutlist.push(
                  setTimeout(() => {
                    var oldP = { //旧的相机位置
                      x: _this.camera.position.x,
                      y: _this.camera.position.y,
                      z: _this.camera.position.z,
                    }
                    var oldT = { //旧的聚焦位置
                      x: _this.controls.target.x,
                      y: _this.controls.target.y,
                      z: _this.controls.target.z,
                    }
                    var newT = { //新的聚焦位置
                      x: 0,
                      y: 0,
                      z: 0,
                    }
                    var newP = { //新的相机位置
                      x: 50,
                      y: 30,
                      z: 70,
                    }
                    _this.tweenCamera(oldP, oldT, newP, newT);
                  }, 1900)
                )
                break;
              default:
                break;
            }
          },
          /**
           * @description 菜单选项2
           * @param {Number} e 菜单选项对象
           */
          outerAnimate: function(item) {
            let _this = this;
            this.outerActive = item.id
            this.downActive = null
            this.upperActive = null
            this.selectobject = item
            this.showallcomponents()
            this.initmodel()
            this.clearsettimeout()
            this.attentionStatus = true
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(item.show_name){ //显示
              _this.ShowHideComponents(item.show_name,true)
            }
            if(item.hide_name){ //隐藏
              _this.ShowHideComponents(item.hide_name,false)
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            if(item.animate_number){
              //包含关键帧动画的模型作为参数创建一个播放器
              _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
              //  获取gltf.animations[0]的第一个clip动画对象
              _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
              _this.clipAction.play(); //播放动画
              _this.clipAction.loop = THREE.LoopOnce; //不循环播放
              _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            }
            if(item.camera_position){
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: item.camera_position.x,
                y: item.camera_position.y,
                z: item.camera_position.z,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
          },
          //显示隐藏注意提示
          shownote(){
            this.is_hidenote = !this.is_hidenote
          },
          /**
           * @description 射线拾取模型
           */
          raycasterclick(){
            let _this = this
            _this.renderer.domElement.addEventListener('click', function (event) {
              // .offsetY、.offsetX以canvas画布左上角为坐标原点,单位px
              const px = event.offsetX;
              const py = event.offsetY;
              //屏幕坐标px、py转WebGL标准设备坐标x、y
              //width、height表示canvas画布宽高度
              const x = (px / event.srcElement.clientWidth) * 2 - 1;
              const y = -(py / event.srcElement.clientHeight) * 2 + 1;
              //创建一个射线投射器`Raycaster`
              const raycaster = new THREE.Raycaster();
              //.setFromCamera()计算射线投射器`Raycaster`的射线属性.ray
              // 形象点说就是在点击位置创建一条射线，射线穿过的模型代表选中
              raycaster.setFromCamera(new THREE.Vector2(x, y), _this.camera);
              //.intersectObjects([mesh1, mesh2, mesh3])对参数中的网格模型对象进行射线交叉计算
              // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
              const intersects = raycaster.intersectObjects([_this.model]);
              // console.log("射线器返回对象", intersects);
              // intersects.length大于0说明，说明选中了模型
              if (intersects.length > 0) {
                console.log("射线器返回对象", intersects);
              }else{
                console.log('null');
              }
            })
          },
          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
            this.$refs.navchild.childchangelang();
            if (this.lang == 'cn') {
              if(this.selectobject.warn){
                this.attentionText = this.selectobject.warn;
              }else{
                this.attentionText = null
              }
            } else {
              if(this.selectobject.en_warn){
                this.attentionText = this.selectobject.en_warn;
              }else{
                this.attentionText = null
              }
            }
          },
          /**
           * @description 显示所有组件
           */
          showallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              object.visible = true
              if (object.isMesh) {
                object.material.opacity = 1
              }
            })
          },
          /**
           * @description 隐藏所有组件
           */
          hideallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              if(object.isMesh){
                object.visible = false
              }
            })
          },
          /**
           * @description 透明组件/取消透明
           * @param {array} e 透明名列表
           * @param {number} e （透明度）
           * @param {Boolean} e （0透明）or（1取消透明）
           */
          transparentComponents(objectArray,opcity,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.transparent = false
                  _this.model.getObjectByName(objectArray[i]).material.opacity = 1
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = false
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = 1
                  }
                }
              }
            }else{ //透明
              console.log(objectArray);
              console.log(objectArray.length);
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  // _this.model.getObjectByName(objectArray[i]).material = new THREE.MeshBasicMaterial({ transparent: true, side: THREE.DoubleSide, depthWrite: false });
                  // _this.model.getObjectByName(objectArray[i]).material.color.set("#222")
                  _this.model.getObjectByName(objectArray[i]).material.transparent = true
                  _this.model.getObjectByName(objectArray[i]).material.opacity = opcity
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    // _this.model.getObjectByName(objectArray[i]).children[j].material = new THREE.MeshBasicMaterial({ transparent: true, side: THREE.DoubleSide, depthWrite: false });
                    // _this.model.getObjectByName(objectArray[i]).children[j].material.color.set("#222")
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = true
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = opcity
                  }
                }
              }
            }
          },
          /**
           * @description 显示隐藏组件
           * @param {array} e 隐藏名列表
           * @param {Boolean} e （0隐藏）or（1显示）
           */
          ShowHideComponents(objectArray,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                _this.model.getObjectByName(objectArray[i]).visible = true
              }
            }else{ //隐藏
              for (let i = 0; i < objectArray.length; i++) {
                console.log(_this.model.getObjectByName(objectArray[i]),objectArray[i]);
                _this.model.getObjectByName(objectArray[i]).visible = false
              }
            }
          },
          //初始化状态
          initmodel(){
            let _this = this
            _this.showallcomponents()
            _this.ShowHideComponents(["zx2","yuanzhu","zuoban2","zjt1","zjt2","yjt1","yjt2","zjx2","luowen3"],false)
          },
          /**
           * @description 测试按钮
           */
          test(){
            let _this = this
            _this.transparentComponents(["lg"],0.3)
            // console.log(_this.model.getObjectByName("YC"),"YC");
            // console.log(_this.model.getObjectByName("yougan"),"yougan");
            // console.log(_this.model.getObjectByName("LAN"),"LAN");
            // console.log(_this.model.getObjectByName("LV"),"LV");
            // for (let i = 1; i < 7; i++) {
            //   console.log(_this.model.getObjectByName("HG"+i),"HG"+i);
            // }
            // for (let i = 1; i < 4; i++) {
            //   console.log(_this.model.getObjectByName("HX"+i),"HX"+i);
            // }
          },
        },
        mounted: function () {
          let _this = this;
          _this.initCanvas();
          _this.timer = setInterval(function() {
              if ( !_this.hadLoaded ) {
                  if ( _this.loadprogress < 80 ) {
                      _this.loadprogress += 0.8;
                  } else if ( _this.modelLoaded ) {
                      if ( _this.loadprogress <= 100 ) {
                          _this.loadprogress += 2;
                      } else {
                          _this.hadLoaded = true;
                          clearInterval(_this.timer);
                          _this.timer = null;
                      }
                  }
              }
          }, 20);
          // this.raycasterclick()
          window.addEventListener("resize", _this.onResize, false);
          if(sessionStorage.getItem('language')){
            this.lang = sessionStorage.getItem('language'); // 存入一个值
          }else{
            sessionStorage.setItem('language',this.lang); // 存入一个值
          }
        },
        beforeDestroy(){
          let _this = this
          _this.scene.remove(_this.model)
          _this.model.traverse(function (object) {
            if (object.type === 'Mesh') {
              object.geometry.dispose()
              object.material.dispose()
            }
          })
        },

    }
</script>

<style scoped>
  .v-enter{
    opacity: 0;
  }
  .v-enter-to{
    opacity: 1;
  }
  .v-enter-active{
    transition: all 1s;
  }
  .v-leave{
    opacity: 1;
  }
  .v-leave-to{
    opacity: 0;
  }
  .v-leave-active{
    transition: all 1s;
  }
  .test{
    position: absolute;
    z-index: 10000;
    top: 0px;
    background-color: red;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/jlbmodel.vue